import React from "react";
import { Tooltip } from "@material-ui/core";
import { Warning as WarningIcon } from "@material-ui/icons";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  warning: {
    display: "inline-flex",
    alignItems: "center",
    marginLeft: theme.spacing(1),
    color: "#ffb300",
    fontWeight: 500,
    whiteSpace: "nowrap",
  },
  // On a highlighted row (the selected song on desktop) amber on the accent
  // colour is hard to read, so it takes the row's own text colour instead.
  inheritColor: { color: "inherit" },
  icon: {
    fontSize: "1rem",
    marginRight: theme.spacing(0.5),
  },
}));

// Small "no lyrics" flag shown on a song's line in the Catalog, so songs that
// still need lyrics are easy to spot while scrolling the list.
export default function NoLyricsWarning({ inheritColor = false }) {
  const classes = useStyles();
  return (
    <Tooltip title="No lyrics added yet">
      <span
        className={`${classes.warning} ${inheritColor ? classes.inheritColor : ""}`}
        aria-label="No lyrics added yet"
      >
        <WarningIcon className={classes.icon} />
        No lyrics
      </span>
    </Tooltip>
  );
}
